<template>
  <md-menu class="sort-menu" md-size="auto" md-direction="bottom-start" :md-offset-y="4">
    <a class="sort-menu-trigger" md-menu-trigger :title="$t('products.sort.title')">
      {{ label }}
      <i class="fa" :class="active ? (active.ascending ? 'fa-sort-up' : 'fa-sort-down') : 'fa-sort'"></i>
    </a>
    <md-menu-content class="sort-menu-content">
      <md-menu-item v-for="o in options" :key="o.key" @click="choose(o.key)">
        <span :class="{ 'sort-menu-item--active': active && active.column === o.key }">{{ o.label }}</span>
        <i v-if="active && active.column === o.key" class="fa" :class="active.ascending ? 'fa-sort-up' : 'fa-sort-down'"></i>
      </md-menu-item>
    </md-menu-content>
  </md-menu>
</template>

<script>
/** Spaltenkopf mit Auswahl, wonach sortiert wird (fuer Spalten mit mehreren Werten untereinander). */
export default {
  name: "SortMenu",
  props: {
    label: { type: String, default: "" },
    /** [{ key, label }] - key ist der orderBy-Wert der API */
    options: { type: Array, required: true },
    /** aktuelle Sortierung { column, ascending } */
    order: { type: Object, default: null },
  },
  computed: {
    active() {
      return this.order && this.options.some((o) => o.key === this.order.column) ? this.order : null;
    },
  },
  methods: {
    // Erneuter Klick auf dieselbe Kennzahl dreht die Richtung; neue Kennzahl startet absteigend (groesste zuerst)
    choose(key) {
      const ascending = this.active && this.active.column === key ? !this.active.ascending : false;
      this.$emit("sort", key, ascending);
    },
  },
};
</script>

<style>
.sort-menu-trigger {
  cursor: pointer;
  white-space: nowrap;
}
.sort-menu-trigger .fa {
  margin-left: 4px;
}
/* md-size="auto" setzt die Breite des Spaltenkopfs; die Kennzahlnamen sind laenger (Trello 3b9GL2pS, Update O) */
.md-menu-content.sort-menu-content {
  width: auto !important;
  min-width: 260px;
  max-width: 90vw;
  max-height: 70vh;
}
.sort-menu-content .md-list-item-text,
.sort-menu-content .md-list-item-content > span {
  white-space: nowrap;
}
/* Das Theme setzt Spans im Menue absolut - der Pfeil laege sonst auf dem Text (Update 03.11., O) */
.sort-menu-content .md-list-item-content > span {
  position: static;
}
.sort-menu-content .md-list-item-content {
  justify-content: space-between;
  gap: 12px;
  min-height: 34px;
  font-size: 13px;
}
.sort-menu-item--active {
  font-weight: 600;
  color: #7f915a;
}
</style>
